import React, { useState } from 'react';
import { useSelector } from "react-redux";
import {
  Grid,
  IconButton, Typography
} from '@material-ui/core';
import { AddCircleOutline } from "@material-ui/icons";
import MenuList, { MenuListItem } from "../../../../components/MenuList";
import ModalWithToggle from "../../../../components/ModalWithToggle";
import {
  selectTechnologyConfigurationListByCountryId
} from "../../../../store/technologyConfigurationStore/technologyConfigurationSelectors";
import { selectCurrentCountryId } from "../../../../store/countryStore/countrySelectors";
import WirelessInterfaceModel from "../../../../models/WirelessInterfaceModel";
import { selectAllLicenceList } from "../../../../store/licenceStore/licenceSelectors";
import LicenceTableData from "../../../../components/LicenceTableData";
import { Toolbar } from "../../../../app/components";

import classes from './index.module.scss';

interface AddWirelessInterfaceDialogProps {
  onAdd: (technologyConfigurationId: number, licenceId?: number) => any,
  disabled: boolean,
  wirelessInterfaces: WirelessInterfaceModel[],
}

export const AddWirelessInterfaceDialog = (props: AddWirelessInterfaceDialogProps) => {
  const { onAdd, disabled = false, wirelessInterfaces = [] } = props;
  const [ currentTechnologyId, setCurrentTechnologyId ] = useState(0);
  const [ currentLicenceId, setCurrentLicenceId ] = useState(0);

  const currentCountryId = useSelector(selectCurrentCountryId);

  const licenceList = useSelector(selectAllLicenceList);

  const currentDeviceTechnologiesId = wirelessInterfaces.map((wirelessInterface) => wirelessInterface.technologyConfigurationId);
  const allTechnologyConfigurations = useSelector(selectTechnologyConfigurationListByCountryId(currentCountryId));
  const availableTechnologies = allTechnologyConfigurations.map((technologyConfiguration) =>
    !currentDeviceTechnologiesId.includes(technologyConfiguration.id) && technologyConfiguration).filter(Boolean);

  const selectedTechnology = availableTechnologies.find((tech) => tech && tech.id === currentTechnologyId);
  const isCurrentTechnologyLicenced = selectedTechnology ? selectedTechnology.isLicenced : false;

  const licenceListToShow = licenceList.filter((licence) => licence.technologyId === currentTechnologyId);
  const isBtnDisabled = availableTechnologies.length === 0;
  const isAddBtnDisabled = isCurrentTechnologyLicenced ? !currentLicenceId : !currentTechnologyId;

  const onTechnologyChoose = (id: number) => {
    setCurrentTechnologyId(id);
    setCurrentLicenceId(0);
  }

  const handleOk = () => {
    if (currentTechnologyId) {
      if (isCurrentTechnologyLicenced && currentLicenceId) {
        onAdd(currentTechnologyId, currentLicenceId)
      } else {
        onAdd(currentTechnologyId);
      }
    }

    setCurrentTechnologyId(0);
  };

  const onDialogClose = () => {
    setCurrentTechnologyId(0);
    setCurrentLicenceId(0);
  }

  return (
    <ModalWithToggle
      title={isCurrentTechnologyLicenced ? `Select Licence for ${selectedTechnology ? selectedTechnology?.name : ''}` : "Select Technology"}
      confirmButtonText="Add"
      confirmButtonHandler={handleOk}
      fixedHeight
      onClose={onDialogClose}
      fullSize={isCurrentTechnologyLicenced}
      isConfirmButtonDisabled={isAddBtnDisabled}
      modalContent={(
        <Grid container direction="row" wrap='nowrap'>
          <Grid item xs={isCurrentTechnologyLicenced ? 6 : 12}>
            <Toolbar title={'Technology list'} />
            <MenuList
              selectItem={onTechnologyChoose}
              items={availableTechnologies as MenuListItem[]}
              size='small'
              selectedItemId={currentTechnologyId}
            />
          </Grid>
          {
            isCurrentTechnologyLicenced ? licenceListToShow.length > 0 ? (
              <Grid item xs={6}>
                <Toolbar title={'Licence list'} />
                <LicenceTableData
                  licenceList={licenceListToShow}
                  onSelect={(value) => setCurrentLicenceId(value)}
                  selectedId={currentLicenceId}
                />
              </Grid>
            ) : (
              <>
                <Grid container item xs={5} alignContent='center' justifyContent='center'
                      className={classes.noItemContainer}>
                  <Grid item className={classes.noItemText}>
                    <Typography noWrap component="h2" color="textPrimary">
                      No licence available
                      for <strong>{selectedTechnology ? selectedTechnology?.name : ''}</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </>
            ) : null
          }
        </Grid>
      )}
    >
      <IconButton
        component="span"
        color="secondary"
        size="small"
        disabled={isBtnDisabled || disabled}
      >
        <AddCircleOutline />
      </IconButton>
    </ModalWithToggle>
  );
};
